module.exports = __webpack_public_path__ + "images/templates/footer/AmEx.svg";


//////////////////
// WEBPACK FOOTER
// ./images/templates/footer/AmEx.svg
// module id = 91
// module chunks = 0